import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { VentanillaService } from '../../services/ventanilla.service';


export interface DialogData {
  id_productor: number;
}

@Component({
  selector: 'app-pop-apoyos',
  templateUrl: './pop-apoyos.component.html',
  styleUrls: ['./pop-apoyos.component.css']
})
export class PopApoyosComponent implements OnInit {
  public programasDisponibles;
  public mensaje;
  public upaeg;

  constructor(
    public dialogRef: MatDialogRef<PopApoyosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private ventanillaService: VentanillaService,
  ) {
    this.programasDisponibles = null;
    this.mensaje = '';
    this.upaeg = false;
  }

  ngOnInit() {
    this.getApoyosDisponibles();
  }

  getApoyosDisponibles(){
    this.ventanillaService.getApoyosForUpaeg(this.data.id_productor).subscribe(response => {
      console.log(response);
      this.upaeg = false;
      this.programasDisponibles = null;
      if(response.status){
        if(response.upaeg){
          this.upaeg = response.upaeg;
        }else{
          this.upaeg = false;
        }


        if(response.programas){
          this.programasDisponibles = response.programas;
          this.mensaje = '';
        }else{
          this.programasDisponibles = response.programas;
          this.mensaje = 'No hay apoyos disponibles para la unidad de producción seleccionada';
        }
      }else{
        this.programasDisponibles = null;
        this.mensaje = response.message;
      }
    }, error => {
      console.log(error);
      this.programasDisponibles = null;
      this.mensaje = 'No se pueden cargar los apoyos disponibles en este momento, por favor intente más tarde';
    });
  }

}
